module.exports = __webpack_public_path__ + "img/onboarding-step-4.6658250f.png";